import { AlertTriangle } from 'lucide-react';
import { Text } from '@/components/ui/Text';

/**
 * Total-failure banner shown when `partialFailure:true && hits:[]`.
 * Design §6.6 — surface a clear degraded-state message; never silently fail.
 */
export function GlobalSearchUnavailable() {
  return (
    <div
      role="alert"
      className="flex items-start gap-2.5 mx-3 my-3 px-3 py-2.5 rounded-lg bg-warning/10 border border-warning/20"
    >
      <AlertTriangle
        size={16}
        className="text-warning shrink-0 mt-0.5"
        aria-hidden
      />
      <Text variant="body-sm" color="warning" as="span">
        Search is partially unavailable — some results may be missing. Please
        try again in a moment.
      </Text>
    </div>
  );
}
